import React, { useState, useEffect } from "react";
import { getCookie } from "../../utils/cookies";
import axios from "axios";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Trash } from "react-bootstrap-icons";
import AlertDialog from "../../ui/alerts/AlertDialog";

export default function DeleteServiceType({ fetchData, id }) {
  // Form Modal state
  const [showDelete, setShowDelete] = useState(false);

  // Show and Hide Form Modal
  const handleClose = () => setShowDelete(false);
  const handleShow = () => setShowDelete(true);

  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);

  // Success Dialog State
  const [showSuccess, setShowSuccess] = useState(false);

  // Error Dialog State
  const [showError, setShowError] = useState(false);

  // DELETE
  const deleteServiceType = async (id: number) => {
    try {
      const JWT = await getCookie("ea1-auth");
      const { data } = await axios(
        `https://ea1-dev.azurewebsites.net/api/serviceType/${id}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: JWT,
          },
        }
      );

      setData(data);
      setIsLoading(false);

      // Hides Modal on submission
      setShowDelete(false);

      // Success Alert Popup
      setShowSuccess(true);
    } catch (e) {
      setIsLoading(false);

      // Hides Modal on submission
      setShowDelete(false);

      // Error Alert Popup
      setShowError(true);
    }
  };

  // Table state update on submit
  useEffect(() => {
    fetchData(data);
  }, []);

  const deleteServiceModal = (
    <Modal show={showDelete} backdrop='static' onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Delete Service Type</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to delete this Service Type? This process cannot
        be undone.
      </Modal.Body>
      <Modal.Footer>
        <Button variant='outline-dark' onClick={handleClose}>
          Cancel
        </Button>
        <Button
          type='submit'
          variant='danger'
          onClick={() => deleteServiceType(id)}
        >
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );

  const successAlert = (
    <Modal
      show={showSuccess}
      onHide={() => {
        setShowSuccess(false);
        handleClose();
      }}
      backdrop='static'
    >
      <Modal.Header
        closeButton
        style={{ backgroundColor: "#00E676" }}
      ></Modal.Header>
      <AlertDialog
        title={"Success!"}
        message={"Service Type was successfully deleted."}
      />
    </Modal>
  );

  const errorAlert = (
    <Modal
      show={showError}
      onHide={() => {
        setShowError(false);
        handleClose();
      }}
      backdrop='static'
    >
      <Modal.Header
        closeButton
        style={{ backgroundColor: "#FF1744" }}
      ></Modal.Header>
      <AlertDialog
        title={"Error!"}
        message={"There was an error deleting the Service Type."}
      />
    </Modal>
  );

  return (
    <>
      <Trash onClick={handleShow} />
      {deleteServiceModal}
      {successAlert}
      {errorAlert}
    </>
  );
}
